import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './CarouselNavigation.css';

interface CarouselNavigationProps {
  direction: 'left' | 'right';
  onClick: () => void;
  disabled?: boolean;
  ariaLabel: string;
}

/**
 * Arrow button for the Recent Activity carousel (restored from the carousel
 * removed in e8c2ade8, Asana 1219377729700824). A real <button>: disabled at
 * the ends rather than hidden, so keyboard users can tell where the pages stop.
 */
export const CarouselNavigation: React.FC<CarouselNavigationProps> = ({
  direction,
  onClick,
  disabled = false,
  ariaLabel,
}) => (
  <button
    className={`carousel-nav carousel-nav--${direction}`}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
    type="button"
  >
    <span className="carousel-nav__button">
      <FontAwesomeIcon icon={direction === 'left' ? faChevronLeft : faChevronRight} />
    </span>
  </button>
);

export default CarouselNavigation;
